import { render, staticRenderFns } from "./EditCommodity.vue?vue&type=template&id=6c254d6a&scoped=true&"
import script from "./EditCommodity.vue?vue&type=script&lang=js&"
export * from "./EditCommodity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c254d6a",
  null
  
)

export default component.exports